import moment from 'moment';

import * as appConstants from '../../common/constants';

const mapRow = row => ({
    RiskType: row.riskType,
    Qualifier: row.qualifier,
    Bucket: row.bucket,
    EndDate: row.date ? moment(row.date).format(appConstants.dateFormat) : null,
    Label1: row.labelOne,
    Label2: row.labelTwo,
    Amount: row.amount,
    AmountCurrency: row.amountCcy,
    AmountUSD: row.amountUsd,
    ProductClass: row.prodClass,
    TradeID: row.tradeId,
    IMModel: row.imModel
});

const otherMapRow = row => ({
    riskType: row.riskType,
    qualifier: row.qualifier,
    bucket: row.bucket,
    endDate: moment(row.endDate).format(appConstants.dateFormat),
    label1: row.labelOne,
    label2: row.labelTwo,
    amount: row.amount,
    amountCurrency: row.amountCcy,
    amountUSD: row.amountUsd,
    productClass: row.prodClass,
    tradeID: row.tradeId,
    imModel: row.imModel
});

export const inverseMapRow = row => ({
    riskType: row.riskType || '',
    qualifier: row.qualifier || '',
    bucket: row.bucket || '',
    date: row.endDate ? moment(row.endDate).format(appConstants.dateFormat) : '',
    labelOne: row.label1 || '',
    labelTwo: row.label2 || '',
    amount: row.amount.toString() || '',
    amountCcy: row.amountCurrency || '',
    amountUsd: row.amountUSD.toString() || '',
    prodClass: row.productClass || '',
    tradeId: row.tradeID || '',
    imModel: row.imModel || '',
    readOnly: row.readOnly
});

export const pricingParametersGridTransform = gridData => ({
    ...gridData,
    pricingParameters: gridData.pricingParameters.map(row => mapRow(row))
});

export const loadTradesIntoPricingParams = tradeData => (
    tradeData.map(row => inverseMapRow(row))
);

export const importSensitivitiesAdapter = data => (
    {
        alternativePricingParameters: data.alternativePricingParameters.map(row => inverseMapRow(row)),
        pricingParameters: data.pricingParameters.map(row => inverseMapRow(row)),
        error: data.error
    }
);

export const mapSaveAsTemplateRows = (data) => {
    const obj = {
        pricingParameters: data.pricingParameters.map(row => otherMapRow(row)),
        templateName: data.templateName
    };
    return obj;
};
